import { render } from "./CreditsCard.vue?vue&type=template&id=5be7539e"
import script from "./CreditsCard.vue?vue&type=script&lang=js"
export * from "./CreditsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__